window.HmapCustomSourcesSettingsForm = function ($scope, $alert, settingsFactory, brand) {

    var self = this;
    var formName = "hmap-custom-sources-settings-form";
    var _protected = BaseForm.call(self, formName, $scope);


    self.loading = true;
    self.brandId = brand.id;


    self.load = function () {
        self.loading = false;
    };


    self.save = function () {
        var defer = $q.defer();

        self.validator.validate(function (isValid) {
            if (isValid) {


            } else {

                defer.reject();

            }
        });
        return defer.promise;
    };


};
